
  import { Component, Watch } from 'vue-property-decorator'
  import GTextarea from '@/components/core/input/GTextarea.vue'
  import PTitle from '@/components/config/PTitle.vue'
  import { GenioView } from './GenioView'
  import GCostField from '@/components/core/input/GCostField.vue'
  import PSubtitle from '@/components/config/PSubtitle.vue'

@Component({
  components: { PTitle, PSubtitle, GTextarea, GCostField },
})
  export default class ConfigLead extends GenioView {
  valid = false
  formData = {
    // Ya existente
    settings: {
      uniqueExecutive: true,
      automaticAssignment: true,
      sequential: true,
      assignUnmanagedLeads: false,
      assignIfDelayedTasks: false,
      assignUnmanagedLeadsQuantity: 0,
      assignIfDelayedTasksQuantity: 0,
      executiveFewerLeadsInManagement: false,
      executiveFewerLeadsDelayed: false,
      sameExecutiveAssignment: false,
    },
  }

  forceBoolean (field: string) {
    // Forzar conversión booleana
    const boolValue = Boolean(this.formData.settings[field])
    this.$set(this.formData.settings, field, boolValue)

    // Si es automaticAssignment y es false, resetear valores
    if (field === 'automaticAssignment' && !boolValue) {
      this.resetAllSettings()
    }

    // Si sequential cambia, manejar los ajustes correspondientes
    if (field === 'sequential') {
      this.handleSequentialChange(boolValue)
    }

    // Reseteo individual de campos numéricos cuando se desactivan sus switches
    if (field === 'assignUnmanagedLeads' && !boolValue) {
      this.$set(this.formData.settings, 'assignUnmanagedLeadsQuantity', 0)
      this.$set(this.formData.settings, 'executiveFewerLeadsInManagement', false)
    }

    if (field === 'assignIfDelayedTasks' && !boolValue) {
      this.$set(this.formData.settings, 'assignIfDelayedTasksQuantity', 0)
      this.$set(this.formData.settings, 'executiveFewerLeadsDelayed', false)
    }
  }

  resetAllSettings () {
    this.$set(this.formData.settings, 'uniqueExecutive', false)
    this.$set(this.formData.settings, 'sequential', false)
    this.$set(this.formData.settings, 'assignUnmanagedLeads', false)
    this.$set(this.formData.settings, 'assignIfDelayedTasks', false)
    this.$set(this.formData.settings, 'assignUnmanagedLeadsQuantity', 0)
    this.$set(this.formData.settings, 'assignIfDelayedTasksQuantity', 0)
    this.$set(this.formData.settings, 'executiveFewerLeadsInManagement', false)
    this.$set(this.formData.settings, 'executiveFewerLeadsDelayed', false)
    this.$set(this.formData.settings, 'sameExecutiveAssignment', false)
  }

  handleSequentialChange (isSequential: boolean) {
    if (isSequential) {
      // Si es secuencial, desactivar options executiveFewer
      this.$set(this.formData.settings, 'executiveFewerLeadsInManagement', false)
      this.$set(this.formData.settings, 'executiveFewerLeadsDelayed', false)
    } else {
      // Si no es secuencial, todas las assign van a false o 0
      this.$set(this.formData.settings, 'assignUnmanagedLeads', false)
      this.$set(this.formData.settings, 'assignIfDelayedTasks', false)
      this.$set(this.formData.settings, 'assignUnmanagedLeadsQuantity', 0)
      this.$set(this.formData.settings, 'assignIfDelayedTasksQuantity', 0)
      // No resetear executiveFewer pues esas se manejan por separado
    }
  }

  onExecutiveFewerLeadsInManagementChange () {
    if (this.formData.settings.executiveFewerLeadsInManagement) {
      this.$set(this.formData.settings, 'executiveFewerLeadsDelayed', false)
    }
  }

  onExecutiveFewerLeadsDelayedChange () {
    if (this.formData.settings.executiveFewerLeadsDelayed) {
      this.$set(this.formData.settings, 'executiveFewerLeadsInManagement', false)
    }
  }

  async created () {
    // Forzar inicialización como booleanos
    this.$set(this.formData.settings, 'uniqueExecutive', Boolean(this.formData.settings.uniqueExecutive))
    this.$set(this.formData.settings, 'automaticAssignment', Boolean(this.formData.settings.automaticAssignment))
    this.$set(this.formData.settings, 'sequential', Boolean(this.formData.settings.sequential))
    this.$set(this.formData.settings, 'assignUnmanagedLeads', Boolean(this.formData.settings.assignUnmanagedLeads))
    this.$set(this.formData.settings, 'assignIfDelayedTasks', Boolean(this.formData.settings.assignIfDelayedTasks))
    this.$set(this.formData.settings, 'executiveFewerLeadsInManagement', Boolean(this.formData.settings.executiveFewerLeadsInManagement))
    this.$set(this.formData.settings, 'executiveFewerLeadsDelayed', Boolean(this.formData.settings.executiveFewerLeadsDelayed))
    this.$set(this.formData.settings, 'sameExecutiveAssignment', Boolean(this.formData.settings.sameExecutiveAssignment))
  }

  async save () {
    if (!this.$refs.form.validate()) {
      await this.setFieldError()
      return
    }

    // Preparar objeto config con todos los campos
    const settings = {
      uniqueExecutive: Boolean(this.formData.settings.uniqueExecutive),
      automaticAssignment: Boolean(this.formData.settings.automaticAssignment),
      sequential: Boolean(this.formData.settings.sequential),
      assignUnmanagedLeads: Boolean(this.formData.settings.assignUnmanagedLeads),
      assignIfDelayedTasks: Boolean(this.formData.settings.assignIfDelayedTasks),
      assignUnmanagedLeadsQuantity: Number(this.formData.settings.assignUnmanagedLeadsQuantity) || 0,
      assignIfDelayedTasksQuantity: Number(this.formData.settings.assignIfDelayedTasksQuantity) || 0,
      executiveFewerLeadsInManagement: Boolean(this.formData.settings.executiveFewerLeadsInManagement),
      executiveFewerLeadsDelayed: Boolean(this.formData.settings.executiveFewerLeadsDelayed),
      sameExecutiveAssignment: Boolean(this.formData.settings.sameExecutiveAssignment),
    }

    const fields = {
      id: this.process.id,
      config: {
        ...this.process.config,
        settings,
      },
    }

    await this.updateProcess(fields)

    this.$emit('update')
  }

  get disabledSend () {
    const { settings } = this.formData
    // Si no hay asignación automática, no deshabilitar el botón
    if (!settings.automaticAssignment) {
      return false
    }

    // Si tiene asignación automática y es secuencial, permitir guardar
    if (settings.automaticAssignment && settings.sequential) {
      return false
    }

    // Para modo no secuencial, verificar que al menos una opción esté habilitada
    return !settings.executiveFewerLeadsInManagement && !settings.executiveFewerLeadsDelayed
  }

  @Watch('process', { immediate: true, deep: true })
  onConfigChange (newValue: any) {
    if (newValue?.config) {
      // Crear un nuevo objeto settings
      const newSettings = {
        uniqueExecutive: Boolean(newValue?.config?.settings?.uniqueExecutive),
        automaticAssignment: Boolean(newValue?.config?.settings?.automaticAssignment),
        sequential: Boolean(newValue?.config?.settings?.sequential),
        assignUnmanagedLeads: Boolean(newValue?.config?.settings?.assignUnmanagedLeads),
        assignIfDelayedTasks: Boolean(newValue?.config?.settings?.assignIfDelayedTasks),
        assignUnmanagedLeadsQuantity: Number(newValue?.config?.settings?.assignUnmanagedLeadsQuantity) || 0,
        assignIfDelayedTasksQuantity: Number(newValue?.config?.settings?.assignIfDelayedTasksQuantity) || 0,
        executiveFewerLeadsInManagement: Boolean(newValue?.config?.settings?.executiveFewerLeadsInManagement),
        executiveFewerLeadsDelayed: Boolean(newValue?.config?.settings?.executiveFewerLeadsDelayed),
        sameExecutiveAssignment: Boolean(newValue?.config?.settings?.sameExecutiveAssignment),
      }

      // Usar $set para asignar el nuevo objeto
      this.formData = {
        settings: newSettings,
      }
    }
  }
  }
